import { render, staticRenderFns } from "./FormBiaya.vue?vue&type=template&id=0ef615f8&"
import script from "./FormBiaya.vue?vue&type=script&lang=js&"
export * from "./FormBiaya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports